/* O'zbekcha (lotin). Перевод русского словаря.

   ТРЕБУЕТ ВЫЧИТКИ НОСИТЕЛЕМ НА ЗАВОДЕ ДО ЗАПУСКА.

   Отраслевая лексика в цехах Узбекистана смешанная: часть терминов
   заимствована из русского и живёт в речи именно в русской форме
   («brak», «smena», «partiya»), часть имеет узбекское слово, которое
   в одном цехе привычно, а в другом нет. Здесь выбраны формы, наиболее
   распространённые в металлургии и машиностроении, но проверить их
   должен человек, который стоит у этих станков.

   Особенно спорные места, на которые стоит смотреть первыми:
     yaroqsiz                 — окончательный брак. Выбрано заводом
                                при вычитке вместо заимствованного «brak»:
                                с «yaroqli» получается пара «годен / не годен»
     nuqson / defekt          — исправимый дефект
     qayta sozlash            — переналадка
     sozlovchi                — наладчик
     smena boshlig‘i         — мастер. Выбрано заводом при вычитке вместо «usta»:
                                это должность, а не «умелец». «Nazoratchi» и «rahbar»
                                не подошли — заняты контролёром СТК и руководством
     shixta                   — навеска у печи. Слово из металлургии;
                                если у печи говорят иначе — заменить
     chiqindi idishi          — тара под лом */

export default {
  common: {
    cancel: 'Bekor qilish',
    ok: 'Tayyor',
    confirm: 'Tasdiqlash',
    close: 'Yopish',
    refresh: 'Yangilash',
    loading: 'yuklanmoqda…',
    exit: 'Chiqish',
    reset: 'Tozalash',
    comment: 'Izoh',
    commentOptional: 'Izoh (majburiy emas)',
    commentRequired: 'Bu sabab uchun izoh majburiy',
    reason: 'Sabab',
    machine: 'Dastgoh',
    shift: 'Smena',
    theme: 'Mavzu',
    language: 'Til',
    understood: 'Tushunarli',
    noConnection: 'Aloqa yo‘q',
    connected: 'Aloqa bor',
    readOnly: 'ko‘rish',
  },

  login: {
    subtitle: 'Ishlab chiqarishni operativ boshqarish tizimi',
    login: 'Login',
    password: 'Parol',
    submit: 'Kirish',
    checking: 'Tekshirilmoqda…',
    toTerminal: 'Sex terminalidan kirish',
    toPassword: 'Login va parol bilan kirish',
  },

  terminal: {
    machine: 'Dastgoh',
    setupTitle: 'Terminalni sozlash',
    setupHint: 'Qurilma biriktirilmagan. Terminal kodini va u yaratilganda berilgan tokenni kiriting.',
    code: 'Terminal kodi',
    token: 'Qurilma tokeni',
    bind: 'Biriktirish',
    tabNumber: 'Tabel raqami',
    pin: 'PIN',
    pickMachine: 'Dastgohni tanlang',
  },

  op: {
    needTabPin: 'Tabel raqami va PIN',
    needTabPinWhy: 'Tabel raqami va PIN majburiy: mahsulot odamga yoziladi',
    scanOrType: 'Birkani skanerlang yoki kodni kiriting',
    leaveTitle: 'Smenadan chiqish',
    leaveText: 'Chiqish belgilansinmi: {name}?',
    leaveDetail: 'Hozirlik soatlari shu vaqt bilan yopiladi. Smena boshlig‘i smenani yopishda ularni to‘g‘rilay oladi',
    leaveOk: 'Chiqishni belgilash',
    qStart: 'Operatsiya boshlanishi',
    qPause: 'Pauza',
    qDone: 'Operatsiya yakuni',
    qCallSetter: 'Sozlovchini chaqirish',
    qCallSupervisor: 'Smena boshlig‘ini chaqirish',
    byTab: ' · tab. {tab}',
    jobReadyOne: 'Topshiriq ishga tayyor',
    jobReadyMany: 'Topshiriqlar ishga tayyor',
    pressStart: 'Dastgoh yoniga turganingizda «Boshlash»ni bosing',
    chooseOne: 'Qaysi biriga kirishayotganingizni tanlang',
    stockWarn: 'Material sarfi to‘liq hisobdan chiqarilmadi',
    stockWarnHint: 'Mahsulot qabul qilindi. Omborchiga yoki smena boshlig‘iga ayting',
    setupTook: 'Qayta sozlash {time} davom etdi',
    machineIs: '{code} dastgohi.',
    machineIdleHint: '{code} dastgohi. Smena boshlig‘i topshiriq beradi va u shu yerda o‘zi paydo bo‘ladi.',
    viewOnly: 'Ish joyi {code} · faqat ko‘rish.',
    shiftTarget: 'smena topshirig‘ida',
    shiftTargetOf: 'smena topshirig‘ida: {qty} {unit}',
    start: 'Boshlash',
    tabNumber: 'Tabel raqami',
    crewSelfNote: 'Har kim o‘zini belgilaydi: PIN — odam terminal yonida turganini bildiradi',
    mark: 'Belgilash',
    commentRequired: 'Bu sabab uchun izoh majburiy',
    confirm: 'Tasdiqlash',
    commentOptional: 'Izoh (majburiy emas)',
    whatHappened: 'Nima bo‘ldi (majburiy emas)',
    call: 'Chaqirish',
    whoseOutput: 'Mahsulot shu odamga yoziladi. U shu dastgohda smenaga belgilangan bo‘lishi kerak',
    tagCode: 'Birkadagi kod',
    shareNote: '«Ulush» — hisob-kitob: brigada mahsuloti topshirish paytida dastgoh yonida bo‘lganlar orasida teng bo‘lingan. Bu o‘lchov emas, baho.',
    workplace: 'Ish joyi',
    noJob: 'Topshiriq berilmagan',
    noJobHint: 'Smena boshlig‘i topshiriq beradi va u shu yerda o‘zi paydo bo‘ladi.',
    jobFromSupervisor: 'Topshiriqni uchastka ekranida, dastgoh kartasidagi '
      + '«Topshiriq» tugmasi orqali almashtirish mumkin.',
    readOnlyNote: 'Mahsulotni topshirish va operatsiyani yopish — dastgoh terminalidan: '
      + 'hisobda buni aynan kim qilgani qolishi kerak.',
    remaining: 'qoldi',
    of: 'dan',
    byButtons: 'Tugmalar bilan',
    byKeyboard: 'Klaviatura bilan',
    all: 'Hammasi',
    good: 'Yaroqli',
    scrap: 'Yaroqsiz',
    defect: 'Nuqson',
    waste: 'Qaytariladigan chiqindi',
    wasteHint: 'Qirqim, uchlari, qirindi — qayta eritishga ketadigan metall',
    wasteQty: 'Qancha, {unit}',
    wastePlaceholder: 'masalan: g‘altak uchlari',
    pallet: 'Poddon yig‘ildi',
    palletHint: 'Idish poddondagi g‘altaklar soniga qarab hisobdan chiqariladi',
    palletCoils: 'Poddonda nechta g‘altak',
    palletNoNorm: 'norma yo‘q',
    palletFact: 'fakt',
    palletMissing: 'Faktsiz hisobdan chiqarilmaydi: {list}',
    palletQueued: 'Poddon: {n} g‘altak',
    pause: 'Pauza',
    resume: 'Ishni davom ettirish',
    finish: 'Operatsiyani yakunlash',
    pauseReason: 'To‘xtatish sababi',
    doPause: 'To‘xtatish',
    callSupervisor: 'Smena boshlig‘ini chaqirish',
    callSetter: 'Sozlovchini chaqirish',
    callWaiting: 'kuting, chaqiruv tizimga qabul qilindi',
    callSupervisorCalled: 'Smena boshlig‘i chaqirildi',
    callSetterCalled: 'Sozlovchi chaqirildi',
    callWhat: 'Nima bo‘ldi (majburiy emas)',
    callHint: 'Qisqacha: ishga nima xalaqit bermoqda',
    doCall: 'Chaqirish',
    inPlan: 'smena topshirig‘ida',
  },

  /* Сокращение «операция» перед её номером. */
  opSeq: 'op.',

  batch: {
    inWork: 'Ishda',
    notMarked: 'partiya belgilanmagan',
    notMarkedWhy: '— yaroqsiz mahsulot nomsiz qoladi',
    mark: 'Partiyani belgilash',
    scrapBin: 'Chiqindi idishga',
    binNotPicked: 'idish tanlanmagan',
    pickBin: 'Idishni tanlash',
    tagCode: 'Birkadagi kod',
    tagHintBatch: 'Dastgoh yonidagi metallning birkasi',
    tagHintBin: 'Yaroqsiz mahsulot tushadigan bunker birkasi',
    dlgBatch: 'Ishdagi partiya',
    dlgBin: 'Chiqindi idishi',
  },

  tools: {
    leftHours: '{h} soat ish qoldi',
    leftQty: '{n} dona qoldi',
    callNote: 'Asbob: {list}',
    onMachine: 'Dastgohda',
    remove: 'Yechish',
    ok: 'me’yorda',
    soon: 'resurs tugamoqda',
    spent: 'resurs tugadi',
    tellSetter: 'Sozlovchiga xabar berish',
  },

  setup: {
    running: 'Qayta sozlash ketmoqda',
    finish: 'Qayta sozlashni yakunlash',
    took: 'Qayta sozlash vaqti',
    start: 'Qayta sozlashni boshlash',
    startBtn: 'Boshlash',
    button: 'Qayta sozlash',
    hint: 'Masalan: Ø6 dan Ø9 ga',
  },

  crew: {
    onShift: 'Smenada',
    markMe: 'Smenada belgilanish',
    mark: 'Belgilash',
    left: 'Ketdi',
    nobody: 'Hech kim belgilanmagan. Smena tarkibdan boshlanadi',
    pinWhy: 'Har kim o‘zi belgilanadi: PIN odam terminal yonida turganini bildiradi',
    shareHint: '«Ulush» — hisob-kitob: brigada mahsuloti topshirilgan paytda '
      + 'dastgoh yonida bo‘lganlar orasida teng bo‘linadi. Bu o‘lchov emas, baho',
    whoReports: 'Kim topshiradi',
    whoReportsHint: 'Mahsulot shu odam nomiga yoziladi. '
      + 'U shu dastgohda smenada belgilangan bo‘lishi kerak',
    doReport: 'Topshirish',
  },

  andon: {
    reasonNotSet: 'Sabab ko‘rsatilmagan',
    setterCalled: 'Sozlovchi chaqirildi',
    supervisorCalled: 'Smena boshlig‘i chaqirildi',
    plant: 'Korxona',
    shiftNamed: '{code} smenasi',
    token: 'Qurilma tokeni',
    bind: 'Bog‘lash',
    byLogin: 'Login va parol bilan kirish',
    exit: 'Chiqish',
    offline: 'Aloqa yo‘q · ma’lumotlar {ago} oldin',
    notMarked: 'Belgilanmagan',
    noReason: 'sabab ko‘rsatilmagan',
    target: 'maqsad {p}',
    quality: 'yaroqlilik {p}',
    title: 'ANDON',
    setupTitle: 'Taxtani sozlash',
    setupHint: 'Qurilma biriktirilmagan. Taxta kodini va u yaratilganda berilgan '
      + 'qurilma tokenini kiriting.',
    code: 'Taxta kodi',
    unbind: 'Bu taxtani uzish',
    run: 'Ishlamoqda',
    down: 'To‘xtadi',
    maint: 'TX',
    idle: 'Kutmoqda',
    oeeShift: 'Smena OEE',
    goodShift: 'Smenada yaroqli',
    attention: 'E’TIBOR TALAB QILADI',
    calm: 'TINCH',
    allQuiet: 'To‘xtagan uskuna va ochiq chaqiruvlar yo‘q',
  },

  /* Навигация. Оператор видит её каждую смену, поэтому переведена
     целиком, включая конторские разделы: пункт на чужом языке рядом
     с переведёнными читается как поломка, а не как «сюда не ходи». */
  nav: {
    groupShop: "Sex",
    groupQuality: "Sifat",
    groupMetal: "Metall",
    groupPlans: "Rejalar va natijalar",
    operator: "Ish joyi",
    operatorShort: "Joy",
    melt: "Shixta",
    area: "Uchastka",
    maintenance: "Texnik xizmat",
    maintenanceShort: "TX",
    quality: "Nazorat",
    qualityShort: "STK",
    lab: "Laboratoriya",
    labShort: "Lab.",
    certificates: "Sertifikatlar",
    certificatesShort: "Sert.",
    stock: "Materiallar",
    stockShort: "Mater.",
    batches: "Partiyalar",
    scrap: "Chiqindi",
    orders: "Buyurtmalar",
    shift: "Smena",
    production: "Ishlab chiqarish",
    productionShort: "Sharh",
    admin: "Sozlamalar",
    company: "Korxona",
  },

  status: {
    retry: 'Qayta yuborish',
    discard: 'Tashlab yuborish',
    ok: 'Aloqa bor',
    pending: 'Yuborilmoqda: navbatda {n} ta',
    offline: 'Aloqa yo‘q',
    offlineQueued: 'Aloqa yo‘q · navbatda {n} ta',
    degraded: 'Hodisalar mavjud emas, ma’lumotlar so‘rov bo‘yicha yangilanadi',
    blocked: 'Navbat to‘xtadi',
  },

  shift: {
    named: '{code} smena',
    namedWith: '{code} smena · {name}',
    left: '{time} qoldi',
    over: 'smena tugadi',
    noBounds: 'smena chegaralari belgilanmagan',
    hours: '{h} soat',
    hoursMinutes: '{h} soat {m} daqiqa',
    minutes: '{m} daqiqa',
    progress: 'Smena {p}% o‘tdi',
  },

  tool: {
    writeOff: 'resurs tugadi',
    regrind: 'qayta charxlash vaqti',
    soon: 'resurs tugayapti',
  },

  melt: {
    title: 'Shixta',
    subtitle: 'Komponentlar vazni va retseptdagi ulushi. Pech yopilgunga qadar hisoblanadi',
    compCount: '{n} ta komponent',
    hangTag: 'Birkani idishga osib qo‘ying. Bu partiyadan chiqadigan hamma narsa u bilan bog‘lanadi',
    next: 'Keyingi shixta',
    what: 'Nima eritamiz',
    choose: '— tanlang —',
    noRecipes: 'Hech bir materialga retsept berilmagan. Uni sozlamalarda, materiallar ma’lumotnomasida kiriting',
    outTag: 'Natija birkasi',
    other: 'Boshqasi',
    outPh: 'Natija uchun toza birka',
    total: 'Shixtada jami',
    offRecipe: 'Retseptdan tashqari',
    byRecipe: 'retsept bo‘yicha',
    components: 'Komponentlar',
    compPh: 'Komponent birkasi',
    noTag: 'Birkasiz',
    thComponent: 'Komponent',
    thTag: 'Birka',
    thRecipe: 'Retsept bo‘yicha',
    thWeight: 'Vazn',
    thShare: 'Ulush',
    scanTag: 'birkani skanerlang',
    scanOutFirst: 'Shixtani yopish uchun natija birkasini skanerlang',
    close: 'Shixtani yopish',
    pp: 'f.p.',
    tagTaken: '{code} allaqachon bog‘langan — toza birka oling',
    switchTitle: 'Eritilayotgan narsani almashtirish',
    switchText: 'Vaznlar allaqachon kiritilgan. Maqsadni almashtirish qatorlarni boshqa retsept bo‘yicha qayta yig‘adi.',
    switchDetail: 'Kiritilgan vaznlar yo‘qoladi',
    switchOk: 'Almashtirish',
    offTitle: 'Shixta retseptdan chetda',
    offText: 'Ruxsat etilgan chegaradan tashqari: {what}. Shixta baribir yopilsinmi?',
    offTextAny: 'Shixta retseptdan chetda. Baribir yopilsinmi?',
    offDetail: 'Chetlanish eritma yozuvida qoladi va partiyaning kelib chiqish zanjiriga o‘tadi',
  },
  enum: {
    orderStatus: {
      draft: 'Qoralama', pending: 'Kelishuvda', approved: 'Kelishilgan',
      planned: 'Rejalashtirilgan', released: 'Chiqarilgan', run: 'Ishda',
      paused: 'To‘xtatilgan', done: 'Yakunlangan', closed: 'Yopilgan', cancelled: 'Bekor qilingan',
    },
    orderOrigin: { sales: 'Mijoz buyurtmasiga', internal: 'Ichki', stock: 'Omborga' },
    equipmentType: {
      enterprise: 'Korxona', area: 'Sex', workcenter: 'Uchastka',
      machine: 'Uskuna', buffer: 'Bufer zonasi',
    },
    reasonCategory: {
      scrap: 'Yakuniy yaroqsiz', defect: 'Tuzatsa bo‘ladigan nuqson', downtime: 'Rejadan tashqari to‘xtash',
      maint: 'Rejali to‘xtash / TX', pause: 'Operatsiyani to‘xtatib turish', cancel: 'Buyurtmani bekor qilish',
      setup: 'Qayta sozlash',
    },
    defectOrigin: {
      own: 'O‘z bosqichi', upstream: 'Oldingi bosqich', material: 'Kiruvchi material',
      metallurgy: 'Eritma kimyosi', tooling: 'Asbob va uskuna', unknown: 'O‘rnatilmagan',
    },
    equipmentState: {
      run: 'Ishlamoqda', idle: 'Kutmoqda', maint: 'Rejali to‘xtash / TX',
      down: 'To‘xtash / avariya', off: 'O‘chirilgan',
    },
    opStatus: {
      wait: 'Kutmoqda', active: 'Bajarilmoqda', paused: 'To‘xtatilgan',
      done: 'Yakunlangan', skipped: 'O‘tkazib yuborilgan',
    },
    outputKind: { good: 'Yaroqli', scrap: 'Yakuniy yaroqsiz', defect: 'Tuzatsa bo‘ladigan nuqson', rework: 'Qayta ishlangandan keyin', waste: 'Qaytariladigan chiqindi' },
    role: {
      operator: 'Operator', qc: 'STK nazoratchisi', setter: 'Sozlovchi',
      supervisor: 'Smena boshlig‘i', planner: 'Rejalashtiruvchi', manager: 'Rahbariyat',
      admin: 'Administrator',
    },
  },
};
